// extracted by mini-css-extract-plugin
export var active = "_6o-a";
export var activeIndicator = "_6o-8";
export var animate = "_6o-9";
export var disabled = "_6o-b";
export var fullWidth = "_6o-2";
export var lg = "_6o-7";
export var md = "_6o-6";
export var redoButtonTabGroup = "_6o-0";
export var sm = "_6o-5";
export var tabButton = "_6o-3";
export var tabButtonsContainer = "_6o-1";
export var xs = "_6o-4";